import type { AppContext } from './_type';

import { useMemo, useState } from 'react';

import { CONFIRM_CONFIG_MAPPER } from '~/common/constants';

/**
 * App Provider - hook
 */
export const useHooks = () => {
  /** askAgain */
  const [askAgain, setAskAgain] = useState<AppContext['askAgain']>(
    Object.keys(CONFIRM_CONFIG_MAPPER).reduce((obj, key) => ({ ...obj, [key]: true }), {}),
  );

  /** context */
  const context = useMemo<AppContext>(
    () => ({
      askAgain,
      setAskAgain,
    }),
    [askAgain],
  );

  /** return */
  return useMemo(() => ({ context }), [context]);
};
